module.exports = __webpack_public_path__ + "static/export2-min-88bafe60a39319d9742b94fa57015893.png";